import React from 'react';
import SettingForm from "../../components/Admin/ConfigsForm/ConfigsForm";

const SettingFormPage = () => {
  return <SettingForm />;
};

export default SettingFormPage;
